









import Vue from 'vue'
import dayjs from 'dayjs'

export default Vue.extend({
  props: {
    dataValue: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      // tableColumns: [],
      tableData: [],
      bizTypeList: [6, 8, 11],
      scrollHeight: 200,
      tableKey: {}
    }
  },
  computed: {
    tableColumns() {
      return [
        {
          title: this.$t('page_mdc_setting_index') || '序号',
          dataIndex: 'order',
          key: 'order',
          width: 80,
          ellipsis: true,
          customRender: (val, record, arr) => (arr + 1)
        },
        {
          title: this.$t('page_bill_manage_date') || '日期',
          dataIndex: 'date',
          key: 'date',
          width: 100,
          ellipsis: true,
          customRender: val => {
            return val ? dayjs(val).format('YYYY-MM-DD') : ''
          }
        },
        {
          title: this.$t('page_extranet_Machine_name') || '设备名称',
          dataIndex: 'workStationName',
          key: 'workStationName',
          width: 100,
          ellipsis: true
        },
        {
          title: this.$t('page_plan_maintenance_equipment_coding') || '设备编码',
          dataIndex: 'workStationCode',
          key: 'workStationCode',
          width: 130,
          ellipsis: true
        },{
          title: this.$t('page_ops_machine_search_iot_state') || '设备状态',
          dataIndex: 'iotStatus',
          key: 'iotStatus',
          width: 130,
          ellipsis: true,
          customRender: val => {
            if (val) {
              return Number(val) === 1 ? this.$t('page_mdc_status_record_device_alarm') : (Number(val) === 4 ? this.$t('page_mdc_status_record_device_standby') : '')
            } else {
              return ''
            }
          }
        },
        {
          title: this.$t('page_plan_maintenance_start_time') || '开始时间',
          dataIndex: 'startTime',
          key: 'startTime',
          width: 130,
          customRender: val => {
            return val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : ''
          }
        },
        {
          title: this.$t('page_plan_maintenance_end_time') || '结束时间',
          dataIndex: 'endTime',
          key: 'endTime',
          width: 130,
          customRender: val => {
            return val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : ''
          }
        },
        {
          title: this.$t('page_mdc_status_record_duration') || '持续时长',
          dataIndex: 'duration',
          key: 'duration',
          width: 100,
          ellipsis: true
        },
        /*{
          title: this.$t('page_mdc_status_record_exception_description') || '异常描述',
          dataIndex: 'exceptionDescription',
          key: 'exceptionDescription',
          width: 100,
          ellipsis: true
        }*/

      ]
    }
  },
  mounted() {
    this.initTableData()
    this.getHeight()
  },
  methods: {
    getHeight() {
      const height = document.querySelector('.main-body').clientHeight
      this.scrollHeight = height - 80
    },
    initTableData() {
      let tableData = []
      this.dataValue.map(item=>{
        item.recordItems.map(r=>{
          tableData.push({...r,...item.workStation})
        })
      })
      this.tableData = tableData
    },
  }
})

